import { render } from "./FamilyCreate.vue?vue&type=template&id=1189ed79&scoped=true&ts=true"
import script from "./FamilyCreate.vue?vue&type=script&lang=ts"
export * from "./FamilyCreate.vue?vue&type=script&lang=ts"

import "./FamilyCreate.vue?vue&type=style&index=0&id=1189ed79&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1189ed79"]])

export default __exports__